import { render, staticRenderFns } from "./AgentBadge.vue?vue&type=template&id=7c29d8e7&"
import script from "./AgentBadge.vue?vue&type=script&lang=js&"
export * from "./AgentBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports